import React, { useMemo } from "react";

//MUI
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";

//Components
import WinProbabilityFactorDetail from "./win-probability-factor-detail";

import { useAppSelector } from "../../redux/hooks/redux-hooks";
import Divider from "../Divider";

const WinProbabilityDetails = () => {
  const projectDetails = useAppSelector(
    (state) => state.projectSP.particular_ProjectSP
  );

  const projectQuestions = useAppSelector(
    (state) => state.wpf.projectQuestions
  );

  // To get the go factors NA Count
  const goFactorsNACount = useMemo(() => {
    let count = 0;
    if (
      projectQuestions.goFactorSelectedOptions &&
      projectQuestions.goFactorSelectedOptions.length !== 0
    ) {
      projectQuestions.goFactorSelectedOptions.forEach(({ option }) => {
        if (option.optionDetails.toUpperCase() === "NA") {
          count++;
        }
      });
    }

    return count;
  }, [projectQuestions]);

  // To get the get factors NA Count
  const getFactorsNACount = useMemo(() => {
    let count = 0;
    if (
      projectQuestions.getFactorSelectedOptions &&
      projectQuestions.getFactorSelectedOptions.length !== 0
    ) {
      projectQuestions.getFactorSelectedOptions.forEach(({ option }) => {
        if (option.optionDetails.toUpperCase() === "NA") {
          count++;
        }
      });
    }

    return count;
  }, [projectQuestions]);

  const listQuestions = (type: "go" | "get") => {
    const questions =
      type === "go"
        ? projectQuestions.goFactorSelectedOptions
        : projectQuestions.getFactorSelectedOptions;
    return questions.map(({ question, option }, index) => (
      <WinProbabilityFactorDetail
        key={question.questionId}
        index={index + 1}
        question={question}
        option={option}
      />
    ));
  };

  return (
    <Box sx={{ margin: "0" }}>
      <Typography
        variant="body1"
        sx={{ marginTop: "0.5em", fontWeight: "bold" }}
      >
        Go Get Factor Details:
      </Typography>
      <Divider />
      <div style={{ paddingLeft: "1rem" }}>
        <Grid container mb={1} spacing={3} justifyContent="space-between">
          <Grid item xs={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
              Go Factor:{" "}
              <span style={{ fontWeight: "normal" }}>
                {projectDetails.goFactorPercentage || 0}%
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
              Get Factor:{" "}
              <span style={{ fontWeight: "normal" }}>
                {projectDetails.getFactorPercentage || 0}%{" "}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
              Go Get Factor:{" "}
              <span style={{ fontWeight: "normal" }}>
                {projectDetails.winProbabilityPercentage || 0}%
              </span>
            </Typography>
          </Grid>
        </Grid>
        {projectDetails.manualGoFactorPercentage ||
        projectDetails.manualGetFactorPercentage ? (
          <>
            <Grid container spacing={3} justifyContent="space-between">
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Manual Go Factor:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {projectDetails.manualGoFactorPercentage || 0}%
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Manual Get Factor:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {projectDetails.manualGetFactorPercentage || 0}%{" "}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Manual Go Get Factor:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {projectDetails.manualGoGetFactorPercentage || 0}%
                  </span>
                </Typography>
              </Grid>
            </Grid>
            {projectDetails.manualGoGetFactorRemarks ? (
              <Box mt={2}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  Manual Go Get Factor Remarks
                </Typography>
                <Typography variant="body2">
                  {projectDetails.manualGoGetFactorRemarks}
                </Typography>
              </Box>
            ) : null}
          </>
        ) : null}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ margin: "1em 0 0 0" }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            Go Factors:
          </Typography>
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            NA Count: {goFactorsNACount}
          </Typography>
        </Stack>
        <Divider />
        {listQuestions("go")}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ margin: "1em 0 0 0" }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            Get Factors:
          </Typography>
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            NA Count: {getFactorsNACount}
          </Typography>
        </Stack>
        <Divider />
        {listQuestions("get")}
      </div>
    </Box>
  );
};

export default WinProbabilityDetails;
